import React from "react";

const OrdeIcon = ({className}) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      style={{ fill: "none" }}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 22.75C11.22 22.75 10.46 22.35 9.94 21.65L8.93 20.3C8.72 20.02 8.44 19.86 8.14 19.84C7.84 19.83 7.54 19.96 7.3 20.21L6.73 19.7L7.28 20.21C5.84 21.75 4.73 21.63 4.2 21.42C3.66 21.21 2.75 20.52 2.75 18.3V7.04C2.75 2.6 4.03 1.25 8.22 1.25H15.78C19.97 1.25 21.25 2.6 21.25 7.04V18.3C21.25 20.51 20.34 21.2 19.8 21.42C19.27 21.63 18.17 21.75 16.72 20.21C16.48 19.95 16.18 19.81 15.87 19.84C15.57 19.86 15.28 20.02 15.07 20.3L14.06 21.65C13.54 22.35 12.78 22.75 12 22.75ZM8.08 18.33C8.12 18.33 8.17 18.33 8.21 18.33C8.95 18.37 9.65 18.76 10.12 19.39L11.13 20.74C11.62 21.39 12.37 21.39 12.86 20.74L13.87 19.39C14.35 18.76 15.04 18.37 15.79 18.33C16.53 18.29 17.27 18.6 17.81 19.18C18.57 19.99 19.06 20.09 19.24 20.02C19.48 19.92 19.74 19.34 19.74 18.3V7.04C19.74 3.43 19.11 2.75 15.77 2.75H8.22C4.88 2.75 4.25 3.43 4.25 7.04V18.3C4.25 19.35 4.51 19.93 4.75 20.02C4.92 20.09 5.42 19.99 6.18 19.18C6.72 18.63 7.39 18.33 8.08 18.33Z"
        fill="#111827"
      />
      <path
        d="M16.23 11.75H10.73C10.32 11.75 9.97998 11.41 9.97998 11C9.97998 10.59 10.32 10.25 10.73 10.25H16.23C16.64 10.25 16.98 10.59 16.98 11C16.98 11.41 16.64 11.75 16.23 11.75Z"
        fill="#111827"
      />
      <path
        d="M16.23 7.75H10.73C10.32 7.75 9.97998 7.41 9.97998 7C9.97998 6.59 10.32 6.25 10.73 6.25H16.23C16.64 6.25 16.98 6.59 16.98 7C16.98 7.41 16.64 7.75 16.23 7.75Z"
        fill="#111827"
      />
      <path
        d="M7.78003 8C7.23003 8 6.78003 7.55 6.78003 7C6.78003 6.45 7.23003 6 7.78003 6C8.33003 6 8.78003 6.45 8.78003 7C8.78003 7.55 8.33003 8 7.78003 8Z"
        fill="#111827"
      />
      <path
        d="M7.78003 12C7.23003 12 6.78003 11.55 6.78003 11C6.78003 10.45 7.23003 10 7.78003 10C8.33003 10 8.78003 10.45 8.78003 11C8.78003 11.55 8.33003 12 7.78003 12Z"
        fill="#111827"
      />
    </svg>
  );
};

export default OrdeIcon;
